import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InternalTransferSubmit, RegularISubmit, SubmitResponse } from '@interfaces';
import { FraudOutcome } from '@interfaces/fraud-detector/fraud-detector.interface';
import { InternalTransferPayload } from '@interfaces/submit/internal-transfer-co0-payload.interface';
import { RecaptchaMockResult } from '@interfaces/submit/submit.service.interface';
import { IOpenAccount } from '@shared/models';
import { Observable } from 'rxjs';

import { LoggerService } from '../../modules/logger/logger';
import { FMFResponse } from '../fraud-micro-frontend/fmf.service';

@Injectable({
  providedIn: 'root',
})
export class SubmitService {
  constructor(
    private http: HttpClient,
    private loggerService: LoggerService,
  ) {}

  submitEndpoint(
    submitData: RegularISubmit,
    fmfResponse: FMFResponse,
    mockRecaptchaLevel: RecaptchaMockResult,
  ): Observable<any> {
    return this.http.post(`secure/submit`, {
      ...submitData,
      fmfResponse,
      mockRecaptchaLevel,
    });
  }

  submitInheritedIraEndpoint(
    submitData: RegularISubmit,
    fmfResponse: FMFResponse,
    mockRecaptchaLevel: RecaptchaMockResult,
  ): Observable<any> {
    return this.http.post(`secure/submit/inherited-ira`, {
      ...submitData,
      fmfResponse,
      mockRecaptchaLevel,
    });
  }

  submitMultiTransactionsEndpoint(
    submitData: RegularISubmit[] | InternalTransferPayload[],
    fmfResponse: FMFResponse,
    oaFMFResponse: FMFResponse | null,
    mockRecaptchaLevel: RecaptchaMockResult,
    oaData: IOpenAccount | null,
    mockFraudDetectorLevel: FraudOutcome | null,
    metricsCorrelationId: string,
  ): Observable<any> {
    return this.http.post(
      `secure/submit-multi-transactions`,
      submitData.map((data: RegularISubmit | InternalTransferPayload) => ({
        ...data,
        fmfResponse,
        oaFMFResponse,
        mockRecaptchaLevel,
        oaData: {
          ...oaData,
          goals: (data as RegularISubmit).config?.investmentObjectives || oaData?.goals,
        },
        mockFraudDetectorLevel,
        metricsCorrelationId,
      })),
    );
  }

  internalTransferSubmitEndpoint(
    submitData: InternalTransferSubmit,
    fmfResponse: FMFResponse,
    mockRecaptchaLevel: RecaptchaMockResult,
  ): Observable<SubmitResponse> {
    return this.http.post<SubmitResponse>(`secure/submit/internal-transfer`, {
      ...submitData,
      fmfResponse,
      mockRecaptchaLevel,
    });
  }
}
